import React from 'react';
import PropTypes from 'prop-types';
import { Form, Select } from 'semantic-ui-react';

const FilterField = ({
  name,
  label,
  placeholder,
  options,
  value,
  onChange,
  multiple,
}) => (
  <Form.Field
    name={name}
    control={Select}
    fluid
    search
    selection
    clearable
    multiple={multiple}
    label={label}
    placeholder={placeholder}
    defaultValue={value}
    options={options}
    onChange={onChange}
  />
);

FilterField.defaultProps = {
  multiple: false,
  value: undefined,
};

FilterField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.instanceOf(Array).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  multiple: PropTypes.bool,
};

export default FilterField;
